import { Box, InputAdornment, makeStyles, MenuItem, TextField } from '@material-ui/core';
import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import TableHeader from '../../../../../theme/components/TableHeader/TableHeader';
import styles from '../Pendencias.style';

const useStyles = makeStyles(styles);

const STATUS_OPTIONS = [
  { value: '', label: 'Todos os status' },
  { value: 'AGUARDANDO_VALIDACAO', label: 'Aguardando Validação' },
  { value: 'VALIDACAO_INTERNA', label: 'Validação Interna' },
  { value: 'APROVADA', label: 'Aprovado' },
  { value: 'RECUSADA', label: 'Rejeitado' },
  { value: 'COM_PENDENCIA', label: 'Com Pendência' },
];

export const PendenciasParametrosFilters = props => {
  const { filters, setFilters } = props;
  const classes = useStyles(props);

  const handleChangeFilter = (filter, value) => {
    setFilters({ ...filters, [filter]: value || null });
  };

  return (
    <TableHeader.Filters>
      <Box display="flex" gridGap="16px" width="100%">
        <Box flex={1}>
          <TextField
            className={classes.filterInput}
            label="Buscar Parceiro"
            placeholder="Buscar por parceiro ou CNPJ"
            value={filters.parceiro || ''}
            onChange={e => handleChangeFilter('parceiro', e.target.value)}
            helperText={
              filters.parceiro?.length > 0 && filters.parceiro.length < 3 ? 'Digite ao menos 3 caracteres' : ' '
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon className={classes.searchIcon} fontSize="large" />
                </InputAdornment>
              ),
            }}
            InputLabelProps={{ shrink: true, style: { color: 'rgba(0, 0, 0, 0.6)' } }}
          />
        </Box>

        <Box flex={1}>
          <TextField
            select
            className={classes.filterInput}
            label="Status"
            value={filters.status || ''}
            onChange={e => handleChangeFilter('status', e.target.value)}
            SelectProps={{ displayEmpty: true }}
            InputLabelProps={{ shrink: true, style: { color: 'rgba(0, 0, 0, 0.6)' } }}
          >
            {STATUS_OPTIONS.map(opt => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Box>
    </TableHeader.Filters>
  );
};

PendenciasParametrosFilters.propTypes = {
  filters: PropTypes.shape({
    parceiro: PropTypes.string,
    status: PropTypes.string,
    documentType: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
};
